<app-overlay-panel mode="center" size="xl" ariaLabel="Geplante Sendungen" (closed)="close()">
  <span overlay-title>
    <span class="op-title-main">Geplante Sendungen — {{ channel }}</span>
    <span class="op-title-sub">{{ date | date: 'mediumDate':'UTC' }}</span>
  </span>

  <div class="voxtral-schedule-body">
      <div *ngIf="errorMessage" class="error-row">
        {{ errorMessage }}
      </div>

      <div *ngIf="rows.length === 0 && !errorMessage" class="empty-row">
        Für {{ channel }} am {{ date | date: 'mediumDate':'UTC' }} sind keine Sendungen vorhanden.
      </div>

      <!-- One card per Sendung (replaces the former 9-column table): same
           structure at every width; 2-col card grid on wide panels, 1-col on
           narrow. Iterates the SAME memoized rows getter with the SAME
           trackBy — the perf machinery in the component is untouched. -->
      <!-- RBAC: für Editor sind ALLE Karten-Controls sichtbar, aber gesperrt.
           Links (<a>) bleiben per HTML-Spez. klickbar (read-only Ansichten). -->
      <fieldset class="rbac-fieldset" disableUnlessPermission="manage-broadcasts">
      <div *ngIf="rows.length > 0" class="sched-cards">
        <article
          *ngFor="let row of rows; trackBy: trackByKey"
          class="sched-card"
          [class.card-scheduled]="row.scheduled"
          [class.card-current]="row.current"
          [class.card-context-open]="isContextOpen(row)">

          <div class="sc-head">
            <span class="sc-time">{{ formatTime(row.startsAt) }} – {{ formatTime(row.endsAt) }}</span>
            <div class="sc-titleblock">
              <span class="sc-title" [title]="row.title || row.key">{{ row.title || row.key }}</span>
              <span class="sc-subtitle" *ngIf="row.subtitle" [title]="row.subtitle">{{ row.subtitle }}</span>
              <span class="sc-key" [title]="row.key">{{ row.key }}</span>
            </div>
            <span class="sc-headactions">
              <!-- Start/Stop: Admin-only (auch für Redakteur gesperrt). -->
              <button
                type="button"
                class="title-action-btn title-start"
                *ngIf="!row.sessionActive && !row.ec2Starting && !row.sessionStarting"
                [disabled]="isStarting(row) || !canControlVoxtral"
                (click)="startVoxtral(row)"
                [title]="canControlVoxtral ? 'Voxtral starten' : 'Nur für Administratoren'">
                <cds-icon shape="play"></cds-icon>
              </button>
              <button
                type="button"
                class="title-action-btn title-stop"
                *ngIf="row.sessionActive || row.ec2Starting || row.sessionStarting"
                [disabled]="isStopping(row) || !canControlVoxtral"
                (click)="stopVoxtral(row)"
                [title]="canControlVoxtral ? 'Voxtral stoppen' : 'Nur für Administratoren'">
                <cds-icon shape="stop"></cds-icon>
              </button>
            </span>
          </div>

          <div class="sc-status">
            <span *ngIf="row.finished" class="status-badge status-finished" title="Voxtral beendet">Voxtral beendet</span>
            <span *ngIf="!row.finished && row.ec2Starting" class="status-badge status-ec2-starting" title="Voxtral EC2 startet">EC2 startet</span>
            <span *ngIf="!row.finished && row.sessionStarting" class="status-badge status-session-starting" title="Voxtral Session wird erstellt">Session wird erstellt</span>
            <a *ngIf="!row.finished && row.sessionActive && row.ec2Ip"
               class="status-badge status-active status-active-link"
               [href]="'http://' + row.ec2Ip"
               target="_blank"
               rel="noopener"
               [title]="'Voxtral-Session aktiv — http://' + row.ec2Ip">läuft</a>
            <span *ngIf="!row.finished && row.sessionActive && !row.ec2Ip" class="status-badge status-active" title="Voxtral-Session aktiv">läuft</span>
            <span *ngIf="!row.finished && row.operatorStoppedAt" class="status-badge status-stopped" title="Manuell gestoppt">manuell gestoppt</span>
            <span *ngIf="row.showPastBadge" class="status-badge status-past" title="Sendung liegt in der Vergangenheit">Vergangen</span>
          </div>

          <div class="sc-body">
            <section class="sc-group" *ngIf="!row.finished">
              <h6 class="sc-group-title" title="FAB Live-Forward an FAB-Endpoint">FAB</h6>
              <label class="toggle-inline">
                <input
                  type="checkbox"
                  [checked]="row.fabEnabled"
                  [disabled]="isFabSaving(row)"
                  (change)="onFabToggle(row, $any($event.target).checked)" />
                <span class="toggle-inline-text">{{ row.fabEnabled ? 'an' : 'aus' }}</span>
                <clr-spinner *ngIf="isFabSaving(row)" clrSmall clrInline></clr-spinner>
              </label>
              <!-- Inline mid-broadcast FAB-URL editor. (ngModelChange)
                   debounces + persists + live-updates via
                   /broadcast/voxtral-fab-url. Visible only when FAB is on. -->
              <span *ngIf="row.fabEnabled" class="sc-faburl-row">
                <input type="text"
                       class="clr-input sc-faburl-input"
                       [ngModel]="row.fabUrl"
                       (ngModelChange)="onFabUrlChanged(row, $event)"
                       [disabled]="isFabUrlSaving(row)"
                       [placeholder]="defaultFabUrlForRow(row)" />
                <clr-spinner *ngIf="isFabUrlSaving(row)" clrSmall clrInline></clr-spinner>
              </span>
              <!-- Per-broadcast DDS-interval FAB gate. When checked (default),
                   voxtral's FAB gate opens only inside accumulated DDS
                   "Programm" segments; unchecked = gate bypassed. Only
                   meaningful when FAB is on. Live-applied on the next FAB tick. -->
              <label class="toggle-inline toggle-top" *ngIf="row.fabEnabled">
                <input
                  type="checkbox"
                  [checked]="row.isFabDdsStartStopActive"
                  (change)="onIsFabDdsStartStopActiveChanged(row, $any($event.target).checked)" />
                <span class="toggle-inline-text"
                      title="Wenn aktiviert, sendet Voxtral nur während der von DDS gemeldeten Programm-Segmente an FAB. Wenn deaktiviert, empfängt FAB jedes Frame (während FAB oben aktiviert ist).">
                  FAB nach DDS Start und Stop aktivieren
                </span>
              </label>
              <div *ngIf="row.fabEnabled && row.ddsIntervals?.length"
                   class="sc-dds-hint"
                   title="Akkumulierte DDS-Programm-Segmente für diese Sendung (lokale Zeit).">
                {{ row.ddsIntervals.length }} Intervalle · {{ formatDdsIntervals(row.ddsIntervals) }}
              </div>
            </section>

            <section class="sc-group">
              <h6 class="sc-group-title" title="Korrektur-Modus (live umschaltbar)">Korrektur</h6>
              <div class="korrektur-cell">
                <select
                  class="clr-select korrektur-select"
                  *ngIf="!row.finished"
                  [disabled]="isCorrectionSaving(row)"
                  [ngModel]="row.correctionMode"
                  (ngModelChange)="onCorrectionModeChange(row, $event)">
                  <option value="phonetic"
                          aria-label="Deterministic Rust phonetic name corrector (eSpeak-IPA + Cologne). Restores mis-spelled proper names toward the roster at microsecond latency."
                          title="Deterministic Rust phonetic name corrector (eSpeak-IPA + Cologne). Restores mis-spelled proper names toward the roster at microsecond latency.">Phonetisch</option>
                  <option value="off">Aus</option>
                  <option value="fuzzy">Fuzzy</option>
                </select>
                <span *ngIf="row.finished" class="korrektur-readonly">{{ row.correctionMode }}</span>
                <button
                  type="button"
                  class="korrektur-context-btn"
                  *ngIf="row.correctionMode !== 'off' && !row.finished"
                  (click)="toggleContextEditor(row)"
                  [title]="isContextOpen(row) ? 'Kontext einklappen' : 'Kontext bearbeiten (komma- oder zeilenweise Werte)'">
                  <cds-icon shape="angle" [attr.direction]="isContextOpen(row) ? 'down' : 'right'" size="14"></cds-icon>
                  <span *ngIf="row.correctionContext" class="korrektur-context-len">{{ row.correctionContext.length }}</span>
                </button>
                <clr-spinner *ngIf="isCorrectionSaving(row)" clrSmall clrInline></clr-spinner>

                <!-- Phase H2 — per-broadcast opt-out for the post-broadcast
                     container restart. Defaults checked. -->
                <label class="korrektur-restart-toggle" *ngIf="!row.finished">
                  <input
                    type="checkbox"
                    [checked]="row.restartAfterBroadcast"
                    (change)="onRestartAfterBroadcastChange(row, $any($event.target).checked)" />
                  <span title="Voxtral-Container nach Sendung neustarten — verhindert vLLM-Status-Anhäufung über Sendungs-Grenzen hinweg (~90s Warmup beim Neustart).">
                    Container nach Sendung neustarten (~90s Warmup)
                  </span>
                </label>
              </div>
            </section>

            <section class="sc-group" *ngIf="sessionApiBase(row) || row.ec2Ip">
              <h6 class="sc-group-title" title="Direktlinks zur Voxtral-Session-API">Links</h6>
              <div class="sc-links">
                <ng-container *ngIf="sessionApiBase(row) as base">
                  <a [href]="base + '/corrections'" target="_blank" rel="noopener" class="session-api-link" title="Letzte Korrekturen (JSON)">/corrections</a>
                  <a [href]="base + '/segments'" target="_blank" rel="noopener" class="session-api-link" title="Segment-Zeitachse (JSON)">/segments</a>
                </ng-container>
              </div>
            </section>
          </div>

          <div class="sc-foot">
            <span class="sc-times" *ngIf="row.ec2StartedAt || row.sessionStartedAt">
              <ng-container *ngIf="row.ec2StartedAt">EC2 {{ formatTimeOfDay(row.ec2StartedAt) }}</ng-container>
              <ng-container *ngIf="row.ec2StartedAt && row.sessionStartedAt"> · </ng-container>
              <ng-container *ngIf="row.sessionStartedAt">Session {{ formatTimeOfDay(row.sessionStartedAt) }}</ng-container>
            </span>
            <label class="toggle-wrapper" *ngIf="!row.finished && !row.past">
              <input
                type="checkbox"
                [checked]="row.scheduled"
                [disabled]="toggleInFlight.has(row.key)"
                (change)="toggle(row)" />
              <span>{{ row.scheduled ? 'Geplant' : 'Nicht geplant' }}</span>
            </label>
          </div>

          <!-- Context drawer hosts the reusable editor (same component as
               details); "Für Sendung übernehmen" persists via
               POST /broadcast/voxtral-correction-context. Expands the card
               to full grid width. -->
          <div *ngIf="isContextOpen(row)" class="sc-context">
            <div class="context-drawer">
              <span class="context-drawer-label">
                Korrektur-Kontext — {{ row.title || row.key }}
              </span>
              <div class="context-drawer-format-hint">
                Werte komma- oder zeilenweise (LF/CRLF) eingeben — beide Formate werden akzeptiert.
              </div>
              <app-voxtral-correction-context-editor
                [currentJson]="row.correctionContext"
                [saving]="isCorrectionSaving(row)"
                (applyToBroadcast)="onCorrectionContextApplied(row, $event)">
              </app-voxtral-correction-context-editor>
            </div>
          </div>
        </article>
    </div>
    </fieldset>
  </div>
</app-overlay-panel>
